import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, TransitionGroup as _TransitionGroup, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ac2fbdf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "cart"
}
const _hoisted_3 = { class: "cart__info" }
const _hoisted_4 = {
  key: 1,
  class: "empty"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "empty__header" }, "Cart is empty", -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "empty__info" }, "Look at the main page to select products or find what you need in the search", -1 /* HOISTED */))

import { storeToRefs } from 'pinia';
import router from '@/router';
import { useCart, usePagination } from '@/store';
import { CartPagination, CartProduct, CartSummary } from '@/components/cart/_index';
import PageCrumbs from '@/components/PageCrumbs.vue';
import ModalWindow from '@/components/modal/ModalWindow.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CartPage',
  setup(__props) {

const { pageProducts, startIndex } = storeToRefs(usePagination());
const { cart } = storeToRefs(useCart());
const crumbs = [{ id: 1, way: 'Cart' }];


return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_unref(cart).length > 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createVNode(PageCrumbs, {
            class: "cart__crumbs",
            crumbs: crumbs
          }),
          _createElementVNode("section", _hoisted_3, [
            _createVNode(_unref(CartPagination)),
            _createVNode(_TransitionGroup, {
              class: "products",
              name: "products-anime",
              tag: "ul"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageProducts), (item, index) => {
                  return (_openBlock(), _createBlock(_unref(CartProduct), {
                    class: "product-anime",
                    item: item,
                    index: index,
                    key: item.product.id
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(index + _unref(startIndex)), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["item", "index"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _createVNode(_unref(CartSummary))
        ]))
      : (_openBlock(), _createElementBlock("section", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createVNode(_component_AppButton, {
            class: "empty__go-main",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'overview' })))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Main")
            ]),
            _: 1 /* STABLE */
          })
        ])),
    _createVNode(ModalWindow)
  ]))
}
}

})